"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnMappingEnumArray = exports.ColumnMappingEnum = void 0;
var ColumnMappingEnum;
(function (ColumnMappingEnum) {
    ColumnMappingEnum["AMOUNT"] = "AMOUNT";
    ColumnMappingEnum["DATE"] = "DATE";
    ColumnMappingEnum["DESCRIPTION"] = "DESCRIPTION";
    ColumnMappingEnum["DESCRIPTION_WITH_IBAN"] = "DESCRIPTION_WITH_IBAN";
    ColumnMappingEnum["VENDOR"] = "VENDOR";
    ColumnMappingEnum["IBAN"] = "IBAN";
    ColumnMappingEnum["CURRENCY"] = "CURRENCY";
    ColumnMappingEnum["NONE"] = "NONE";
})(ColumnMappingEnum || (exports.ColumnMappingEnum = ColumnMappingEnum = {}));
exports.columnMappingEnumArray = Object.values(ColumnMappingEnum);
